// ----------------------------------------------------------------------------
// Component: Announcement Bar Toggle
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

// Constant elements
var ANNOUNCEMENT_BAR           = '.announcement-bar';
var ANNOUNCEMENT_BAR_COPY      = '.announcement-bar__copy';
var ANNOUNCEMENT_BAR_CLOSE     = '.announcement-bar__close';
var HEADER              = '.header';

module.exports = function() {
    if (!$.cookie('hide_announcementBar') || $.cookie('hide_announcementBar') !== $(ANNOUNCEMENT_BAR_COPY).text()) {
        $.removeCookie('hide_announcementBar', { path: '/' });
        $(ANNOUNCEMENT_BAR).addClass('announcement-bar--active');
    }

    $(document).on('click', ANNOUNCEMENT_BAR_CLOSE, _.bind(announcement_bar.close, announcement_bar));
};

var announcement_bar = {
    /**
     * click: Hide Hello Bar when cancelled out of (icon clicked)
     *
     * @param {Event} e
     * @return void
     */
    close: function(e) {

        if(e.preventDefault)
        {
            e.preventDefault();
        }
        else
        {
            e.returnValue = false;
        }

        var helloCopy = $(ANNOUNCEMENT_BAR_COPY).text();

        $(ANNOUNCEMENT_BAR).removeClass('announcement-bar--active');
        $.cookie('hide_announcementBar', helloCopy, { expires: 14, path: '/' });
    }
};
